import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const RecommendationsInProjectListEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "projects-directory-templates-sidebar" */ './index'),
	),
	getPreloadProps: (extraProps: EntryPointRouteParams) => ({
		extraProps,
		queries: {
			templatesQueryRef: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId: extraProps.tenantContext.cloudId,
					isAnonymous: extraProps.tenantContext.isAnonymous,
				},
			},
		},
	}),
});
